import * as R from 'ramda';
import React from 'react';

import styles from 'iss/styles/Input.styl';
import {containedIn} from 'iss/utils/functional';
import {Table} from 'iss/widgets/bootstrap/Table';

/** A version of the bootstrap/Table widget containing selector checkboxes.
 * Adds a column of checkboxes (with select all in the header row) as the
 * first column in the table.
 *
 * Takes all the props a regular Table does and additionally needs the following:
 * selected: An array of selected items
 * onChangeSelected: A callback to handle changes in the selection.
 *                   Gets the updated selected list as a parameter
 */
export function SelectableTable({selected, onChangeSelected, columns, ...props}) {
  const {data} = props;

  const isSelected = containedIn(selected);
  const allSelected = R.all(isSelected, data);
  const toggle = R.pipe(
    item => isSelected(item) ? R.without([item]) : R.append(item),
    R.applyTo(selected), //Apply without or append to the selected list
    R.intersection(data), //Remove stuff that's not in the data anymore
    onChangeSelected
  );
  const toggleAll = () => {
    onChangeSelected(allSelected ? [] : data);
  };

  const selectorColumn = {
    header: data.length ? <input type="checkbox" className={[styles.largeCheckbox, 'selectAll'].join(' ')} checked={allSelected} onChange={e => {e.stopPropagation(); toggleAll();}} /> : null,
    headerProps: {
      onClick: toggleAll,
    },
    accessor: item => {
      return <input type="checkbox" className={styles.largeCheckbox} checked={isSelected(item)} onChange={e => {e.stopPropagation(); toggle(item);}} />;
    },
    cellProps: (item) => ({
      onClick: () => toggle(item),
    }),
  };

  return <Table columns={R.prepend(selectorColumn,columns)} {...props} />;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/SelectableTable.jsx